module.exports = __webpack_public_path__ + "img/tempo_0.474fe601.png";